import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(

  <BrowserRouter>
    <React.StrictMode>
    <LoadScript
          loadingElement={<>Loading...</>}
          version="weekly"
          googleMapsApiKey="AIzaSyAHzQG6CbgD3VdoChRyoYr8qbUm0ZRoBEg"
          libraries={["visualization"]}
        >
      <App />
      </LoadScript>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
